import { cn } from '@wellesley/ui'
import { AppsLink } from '@wellesley/router'
import { UsersPreview } from '@wellesley/user'
import useEventListener from 'hooks/useEventListener'
import { FC, useLayoutEffect, useRef, useState } from 'react'

import UsersPreviewSkeleton from '../../../../Skeletons/UsersPreviewSkeleton'

import PopupArrow from './PopupArrow'
import { AVATAR_SIZE, AVATAR_BORDER_WIDTH } from './constants'
import { PopupAlignment, PopupContentProps } from './types'
import { getPopupAlignment, popupAlignmentClass } from './alignment'

export * from './constants'

const PopupContent: FC<PopupContentProps> = ({
  users,
  counter,
  isLoading,
  actionButtonLink,
}) => {
  const popupRef = useRef<HTMLDivElement>(null)
  const [alignment, setAlignment] = useState<PopupAlignment>('center')

  const updateAlignment = () => {
    if (!popupRef.current) return

    const rect = popupRef.current.getBoundingClientRect()
    setAlignment(getPopupAlignment(rect, window.innerWidth))
  }

  useLayoutEffect(() => {
    updateAlignment()
  }, [])

  useEventListener('resize', updateAlignment)

  return (
    <div
      onClick={(e) => {
        e.stopPropagation()
        e.preventDefault()
      }}
      onPointerDown={(e) => e.stopPropagation()}
    >
      <PopupArrow alignment={alignment} />
      <div
        ref={popupRef}
        data-testid="footer-popup"
        className={cn(
          'p-xxs fade-in gap-xxxs absolute top-[-72px] z-[1] max-w-[calc(100vw-16px)] rounded-lg border border-gray-200 bg-white',
          popupAlignmentClass[alignment],
        )}
      >
        <div className="gap-xxxs flex items-center">
          <>
            {isLoading && (
              <UsersPreviewSkeleton
                size={AVATAR_SIZE + AVATAR_BORDER_WIDTH * 2}
                count={3}
              />
            )}
            {users && users.length > 0 && !isLoading && (
              <UsersPreview
                users={users}
                avatarSize={AVATAR_SIZE}
                borderWidth={AVATAR_BORDER_WIDTH}
              />
            )}
          </>
          <AppsLink to={actionButtonLink}>
            <button className="px-xxs h-s min-w-[47px] rounded-sm bg-gray-100 text-sm font-medium text-gray-900">
              {counter}
            </button>
          </AppsLink>
        </div>
      </div>
    </div>
  )
}

export default PopupContent
